import { useEffect } from 'react'
import Cookies from 'js-cookie'
import {
	isAppInstalled,
	handleAppInstalled,
	handleBeforeInstallPrompt
} from '../utils/appInstallUtils'
import {
	isInStandaloneMode,
	isIos,
	isMacChrome,
	isMacSafari
} from '../utils/deviceUtils'
import {
	pushPWAInstallPromptEvent,
	pushPWAInstalledEvent
} from '../utils/GTMPlugin'
import { getUserAndOrg } from '../utils'

const useAppInstall = ({ setIsInstallPromptVisible, setDeferredPrompt }) => {
	const eventData = getUserAndOrg()
	const userHash = eventData?.userHash || null
	const organisation = eventData?.organisation || null

	useEffect(() => {
		const beforeInstallListener = (e) => {
			e.preventDefault()
			handleBeforeInstallPrompt(e, setDeferredPrompt, setIsInstallPromptVisible)
			pushPWAInstallPromptEvent(organisation, userHash)
		}

		const appInstalledListener = () => {
			handleAppInstalled(setIsInstallPromptVisible)
			pushPWAInstalledEvent(userHash, organisation)
		}
		window.addEventListener('appinstalled', appInstalledListener)
		window.addEventListener('beforeinstallprompt', beforeInstallListener)

		if (
			!Cookies.get('promptDismissed') &&
			!isAppInstalled() &&
			((isIos() && !isInStandaloneMode()) || isMacSafari() || isMacChrome())
		) {
			setIsInstallPromptVisible(true)
		}

		return () => {
			window.removeEventListener('appinstalled', appInstalledListener)
			window.removeEventListener('beforeinstallprompt', beforeInstallListener)
		}
	}, [setIsInstallPromptVisible, setDeferredPrompt, userHash, organisation])
}

export default useAppInstall
